import React from "react";
import {Switch, Route} from "react-router-dom";

import AuthenticateConnection from "components/LM/Bsso/AuthenticateConnection";

const AuthConnect = () => (
	<Switch>
		<Route path="/bsso/connect">
			<AuthenticateConnection></AuthenticateConnection>
		</Route>
	</Switch>
)

export default AuthConnect;
